import { Component, OnInit, ViewChild } from '@angular/core';
import _ from 'lodash';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import {
  ProfileStatuses,
  AllPaymentProfiles
} from '../../../models/all-payment-profiles.model';
import { EngagementSearchAndFilterInput } from '../../../models/engagement-search-and-filter-input.model';
import { AppConstants } from '../../common/app-constants';
import { ExportService } from '../../services/export.service';
import { PaymentProfilesServices } from '../../services/payment-profiles.service';
import { CommonSharedModule } from '../../common/shared.module';

@Component({
  selector: 'app-payment-all-profiles',
  templateUrl: './payment-all-profiles.component.html',
  styleUrls: ['./payment-all-profiles.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class PaymentAllProfilesComponent implements OnInit {
  @ViewChild('allprofilesData', { static: false }) allprofilesData!: Table;

  loading = false;
  excelLoading = false;
  loadingIcon = 'fa-circle-o-notch';
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  totalRecords!: number;
  currentPageInfo!: string;
  tblPageNumber!: number;
  allprofilesList: any = [];
  profilecols!: any[];
  profileStatuses!: ProfileStatuses[];
  profileStatusDrpdwn: SelectItem[];
  displayUpdateBox!: boolean;
  selectedStatus!: SelectItem;
  selectedProfileId!: number;
  searchAndFilterInput: EngagementSearchAndFilterInput =
    new EngagementSearchAndFilterInput();
  currentSearchSubscription!: Subscription;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  delayedLoadSearchContent!: Function;
  programtypes: SelectItem[];

  constructor(
    private profileService: PaymentProfilesServices,
    private exportService: ExportService
  ) {
    this.profileStatusDrpdwn = [];
    this.programtypes = [];
  }

  ngOnInit() {
    this.loading = true;
    this.programtypes = [
      { label: 'MCAP', value: 1 },
      { label: 'CSI', value: 2 },
      { label: 'Operator', value: 3 },
      { label: 'Events', value: 4 },
      { label: 'MRPP', value: 6 }
    ];
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.emptyRecordMsg = AppConstants.emptyRecordMsg;

    this.profilecols = [
      { field: 'allPaymentProfileDetailsId', header: 'Profile Details Id' },
      { field: 'partnerId', header: 'Partner Id' },
      { field: 'payeeEmail', header: 'Payee Email' },
      { field: 'profileStatusId', header: 'Profile Status Id' },
      { field: 'profileStatusName', header: 'Profile Status Name' },
      { field: 'requestorEmail', header: 'Requestor Email' },
      { field: 'reqeustDate', header: 'Request Date' },
      { field: 'programTypeId', header: 'Program Type Id' },
      { field: 'programName', header: 'Program Name' }
    ];
    this.delayedLoadSearchContent = _.debounce(this.loadSearchContent, 1000);
    this.resetFiltersAndLoad();
    this.loadProfileStatuses();
    this.loading = true;
  }

  loadProfileStatuses() {
    this.profileService.getProfileStatuses().subscribe((data: any) => {
      this.profileStatuses = data;
      for (const item of this.profileStatuses) {
        const ftprofilestatuses: SelectItem = {
          label: item.paymentProfileStatusName,
          value: item.paymentProfileStatusId
        };
        this.profileStatusDrpdwn.push(ftprofilestatuses);
      }
    });
  }

  OpenUpdateDialog(rowdata: AllPaymentProfiles) {
    this.displayUpdateBox = true;
    this.selectedProfileId = rowdata.allPaymentProfileDetailsId;
    this.selectedStatus = {
      value: rowdata.profileStatusId,
      label: rowdata.profileStatusName
    };
  }

  resetDialogbox() {
    this.displayUpdateBox = false;
    this.selectedProfileId = 0;
    this.selectedStatus = { value: 0, label: '' };
  }

  updateProfileStatus() {
    const request = {
      profileDetailsID: this.selectedProfileId,
      ProfileStatusId: this.selectedStatus.value
    };
    this.profileService.updateProfileStatus(request).subscribe((data: any) => {
      if (data) {
        this.displayUpdateBox = false;
      }
      this.reset();
    });
    this.displayUpdateBox = false;
  }

  resetFiltersAndLoad() {
    this.searchAndFilterInput = new EngagementSearchAndFilterInput();
    this.searchAndFilterInput.pageSize = AppConstants.dataListRecsPerPage;
    this.searchAndFilterInput.page = 1;
    this.searchOrFilterprofiles();
  }

  searchOrFilterprofiles() {
    this.searchAndFilterInput.page = 1;
    if (this.allprofilesData) {
      this.allprofilesData.first = this.searchAndFilterInput.page;
    }
    this.delayedLoadSearchContent();
  }

  loadSearchContent(e: LazyLoadEvent) {
    this.loading = true;
    this.searchAndFilterInput.computeFilterListParams();
    if (this.currentSearchSubscription) {
      this.currentSearchSubscription.unsubscribe();
    }
    if (e != null) {
      this.searchAndFilterInput.page =
        (e.first ?? 0) == 0 ? 1 : (e.first ?? 0) / this.dataViewRecsPerPage + 1;
      if (e.sortField) {
        this.searchAndFilterInput.sortField = e.sortField;
        this.searchAndFilterInput.sortOrderDescending =
          e.sortOrder == 1 ? false : true;
      }
    }
    this.currentSearchSubscription = this.profileService
      .getAllprofilesdetails(this.searchAndFilterInput)
      .subscribe(
        data => {
          this.allprofilesList = data.results;
          this.totalRecords = data.rowCount;
          this.computeResultsCountText();
          this.loading = false;
        },
        () => {
          this.allprofilesList = [];
          this.totalRecords = 0;
          this.loading = false;
          this.computeResultsCountText();
        }
      );
  }

  reset() {
    this.allprofilesData.reset();
    this.resetFiltersAndLoad();
  }

  exporttocsv() {
    this.profileService.getExportData().subscribe((data: any) => {
      if (data === null || data === undefined) {
        return;
      } else {
        const xdata: any = [];
        data.forEach(element => {
          const xrowdata: any = {};
          Object.entries(element).forEach(([k, v]) => {
            xrowdata[k.toUpperCase()] = v;
          });
          xdata.push(xrowdata);
        });

        const date: Date = new Date();
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const filename =
          'AllPaymentProfileExport.' +
          month.toString() +
          day.toString() +
          year.toString().slice(2);
        this.exportService.exportToCsv(xdata, filename + '.csv');
      }
    });
  }

  exporttompr() {
    this.profileService.downloadmprDocument().subscribe(data => {
      const filename = 'MassPaymentRequest.xlsx';
      const blob: Blob = data.body as Blob;
      const a = document.createElement('a');
      a.download = filename;
      a.href = window.URL.createObjectURL(blob);
      a.click();
    });
  }

  pageChange() {
    this.computeResultsCountText();
  }

  computeResultsCountText() {
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    } else {
      const currentStartCount =
        (this.searchAndFilterInput.page - 1) * this.dataViewRecsPerPage;
      const currentEndCount = currentStartCount + this.dataViewRecsPerPage;
      this.currentPageInfo =
        'Showing ' +
        (currentStartCount + 1) +
        ' - ' +
        (currentEndCount > this.totalRecords
          ? this.totalRecords
          : currentEndCount) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }
}
